import sendGA4Event from "../components/GA4Function";
import GoBackButton from "../components/GoBackButton";

import "../styles/DeshabillerMoiPage.css";



function DeshabillerMoiPage() {
    sendGA4Event("Deshabiller moi", "Visite de page");
    return (
        <div className="page-content-frame">
            <GoBackButton/>
            <div className="deshabiller-moi-content">
                <span className="deshabiller-moi-titre">Des bières à déshabiller, des amis à défier, et des anecdotes à savourer !</span>
                <iframe className="deshabiller-moi-video" src="https://www.youtube.com/embed/v90p0QcasEQ?si=3PkczZKOhTD6-iqz&autoplay=1&loop=1&playlist=v90p0QcasEQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                <div>
                    
                    <span className="deshabiller-moi-desc"> Avec Déshabillez-moi, on t’invite à vivre une expérience brassicole originale et ludique autour de nos bières artisanales locales 🍺</span>
                    <span className="deshabiller-moi-desc">Le principe ? Chaque bière se cache sous une marinière… À toi de jouer !</span>
                    <span className="deshabiller-moi-desc">Scanne le QR code, réponds au quiz et dévoile petit à petit les bières, leurs arômes et leurs anecdotes. Une vraie dégustation à l’aveugle, pour comparer les styles, comprendre les secrets de fabrication et savourer chaque découverte.</span>
                    <span className="deshabiller-moi-desc">💥 <b>Deux expériences en une :</b> la dégustation et la connaissance !</span>
                    <span className="deshabiller-moi-desc">Entre curiosité, partage et plaisir, ce coffret te promet un moment convivial à explorer entre amis, en famille ou entre collègues.</span>
                    <span className="deshabiller-moi-desc">✨ <b>Original, local et plein de caractère,</b> le coffret Déshabillez-moi est disponible directement à la brasserie, ou sur commande à : <a style={{color:"darkred", fontWeight:"bold"}} href="mailto:contact@brasseriesansfacon.fr">contact@brasseriesansfacon.fr</a></span>
                    <br/>
                    <br/>
                </div>            
            </div>
        </div>
    )

}
export default DeshabillerMoiPage;